import { Line } from "react-chartjs-2";
import { Chart as ChartJS, CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend, Filler } from "chart.js";
import { useRef, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { compactNumber } from "../../screens/dashboard/DashboardCard";

ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend, Filler);

ChartJS.defaults.font.family = "Nunito";
ChartJS.defaults.font.size = 10;

const LineChartPD = ({ chartData }) => {
  const [chartDataDisplay, setChartDataDisplay] = useState("sales"); // sales or quantity
  const [chartLabels, setChartLabels] = useState(chartData[0]);
  const [quantityData, setQuantityData] = useState(chartData[1]);
  const [salesData, setSalesData] = useState(chartData[2]);
  const chartRef = useRef(null);

  const { user } = useSelector((state) => state.webStoreUser);

  const options = {
    aspectRatio: 1.2, //1.2
    plugins: {
      legend: {
        position: "top",
        labels: {
          boxWidth: 16,
        },
      },
      title: {
        display: true,
        text: "Amount of Product Sold",
      },
      tooltip: {
        callbacks: {
          // show full value in tooltip (not compact)
          label: (ctx) => `${ctx.dataset.label.trim()}: ${compactNumber(ctx.parsed.y)}`,
        },
      },
    },
    scales: {
      y: {
        ticks: {
          // compact labels on the axis
          callback: (value) => compactNumber(value),
          stepSize: chartDataDisplay === "sales" ? 1000 : 10, // Adjust step size based on data type
        },
        title: {
          display: true,
          text: chartDataDisplay === "sales" ? `Sales (in ${user?.userCountryCurrencySymbol})` : "Quantity Sold (in units)",
        },
        grid: {
          display: true,
        },
      },
      x: {
        grid: {
          display: false,
        },
      },
    },
  };
  const months = ["Jan", "Feb", "Mar", "Apr", "May", "June", "July", "Aug", "Sept", "Oct", "Nov", "Dec"];

  const labels = chartLabels.map((label) => {
    const monthIndex = label % 12; // Assuming label is a number representing the month
    return months[monthIndex];
  });

  const data = {
    labels,
    datasets: [
      {
        label: "Sales (online + in-store)",
        data: chartDataDisplay === "sales" ? salesData : quantityData,
        borderColor: "#5887DE",
        backgroundColor: /* "#0E49B5" */ (ctx) => {
          const chart = ctx.chart;
          const area = chart.chartArea;
          if (!area) {
            // before first draw, fallback to a solid color
            return "rgba(88, 135, 222, 0.4)";
          }
          const { top, bottom } = area;
          const grad = chart.ctx.createLinearGradient(0, top, 0, bottom);
          grad.addColorStop(0, "rgba(88, 135, 222, 0.4)");
          grad.addColorStop(1, "rgba(88, 135, 222, 0)");
          return grad;
        },
        tension: 0.4,
        borderWidth: 1,
        pointRadius: 1.5,
        fill: true, // This is important to create the gradient effect
      },
    ],
  };

  return (
    <div className='line-chartPD'>
      <div className='lineChartTab'>
        <div className='TabTrack764'>
          <button
            onClick={() => {
              setChartDataDisplay("sales");
            }}
            className={chartDataDisplay === "sales" ? "selectedTab764" : ""}
          >
            Sales
          </button>
          <button
            onClick={() => {
              setChartDataDisplay("quantity");
            }}
            className={chartDataDisplay === "quantity" ? "selectedTab764" : ""}
          >
            Quantity
          </button>
        </div>
      </div>
      <Line ref={chartRef} data={data} options={options} />
    </div>
  );
};

export default LineChartPD;
